import { useLazyQuery } from '@apollo/client'
import { Skeleton } from '@mui/material'
import { isNil, uniq } from 'lodash'
import { useEffect } from 'react'

import {
  GetProductsQuery,
  GetProductsQueryVariables,
  ProductFragment,
} from '@/graphql/generated-types'
import { GET_PRODUCTS } from '@/graphql/queries'

import RenderedPlanogram from '../planogram/components/RenderedPlanogram'

type Props = {
  plan: { upc: string }[][]
  reversed?: boolean
  setLoading?: (loading: boolean) => void
}
const PlanogramFromUPCs: React.FC<Props> = ({
  plan,
  reversed = false,
  setLoading,
}) => {
  const [getProducts, { data: productsData, loading: productsLoading }] =
    useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GET_PRODUCTS)

  const upcs: string[] = uniq([
    ...(plan.flatMap(shelf => shelf.flatMap(facing => facing.upc)) || []),
  ]).sort()

  useEffect(() => {
    if (upcs.length > 0) {
      getProducts({
        variables: {
          filters: {
            upcs: uniq(upcs),
          },
        },
      })
    }
  }, [upcs.join(',')])
  const planogramProducts: ProductFragment[][] = plan.map(shelf =>
    shelf
      .map(facing => {
        const product = productsData?.products?.results.find(
          product => product.upcA === facing.upc,
        )
        return product
      })
      .filter(product => !isNil(product)),
  ) as ProductFragment[][]

  useEffect(() => {
    setLoading?.(productsLoading)
  }, [productsLoading])

  return productsLoading ? (
    <>
      <Skeleton />
    </>
  ) : (
    <RenderedPlanogram products={planogramProducts} reversed={reversed} />
  )
}

export default PlanogramFromUPCs
